import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import useGetAllCoinsHistory from "../../hooks/useGetAllCoinsHistory";
import Spinner from "../spinner/Spinner";
import styles from "./CoinsHistoryListStyles.module.css";

type CoinsHistoryEntry = {
  coinsId: number;
  senderId: number;
  receiverId: number;
  coinsGiven: number;
  createdAt: string;
  sender: {
    id: number;
    preferredName: string;
    lastName: string;
    email: string;
  };
  coinReceiver: {
    id: number;
    preferredName: string;
    lastName: string;
    email: string;
  };
};

const CoinsHistoryList = () => {
  const { ref, inView } = useInView();
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useGetAllCoinsHistory();

  const historyList: CoinsHistoryEntry[] =
    data?.pages.flatMap((page: any) => page.coinsHistory) || [];

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, isFetchingNextPage, hasNextPage, fetchNextPage]);

  return (
    <div className={styles.manageAddOnListBlk}>
      <div className={styles.manageProductBlkTitle}>
        <h1>Coins History</h1>
      </div>

      <div className={styles.addOnListMainContainer}>
        {isLoading ? (
          <div style={{ display: "block", padding: "10px 0" }}>
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        ) : historyList.length === 0 ? (
          <p className={styles.notAvailableBlkTxt}>
            No coins history records available
          </p>
        ) : (
          <table className={styles.accessibleTable} aria-label="Coins History">
            <thead>
              <tr>
                <th scope="col">Given By (Admin)</th>
                <th scope="col">Receiver</th>
                <th scope="col">Coins</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {historyList.map((entry: CoinsHistoryEntry) => (
                <tr key={entry.coinsId}>
                  <td>
                    {entry.sender?.preferredName} {entry.sender?.lastName}
                  </td>
                  <td>
                    {entry.coinReceiver?.preferredName}{" "}
                    {entry.coinReceiver?.lastName}
                  </td>
                  <td>
                    <span className={styles.coinsBadge}>
                      {entry.coinsGiven}
                    </span>
                  </td>
                  <td>
                    {entry.createdAt
                      ? new Date(entry.createdAt).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div ref={ref} style={{ height: "1px" }}></div>
        {isFetchingNextPage && (
          <div style={{ display: "block", padding: "20px 0px" }}>
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        )}
      </div>
    </div>
  );
};

export default CoinsHistoryList;
